import react, { Suspense } from 'react';
import OurRoutes from './Routes';
import * as Routers from './Routers';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function AppRouter() {
    return (
        <Router>
            <Suspense>
                <Routes>
                    <Route path={OurRoutes.LOGIN} element={<Routers.LOGIN />}/>
                    <Route path={OurRoutes.MainPage} element={<Routers.MainPage />}/>
                    <Route path={OurRoutes.PRODUCT} element={<Routers.PRODUCT />}/>
                       
                </Routes>
            </Suspense>
        </Router>
    );
}

export default AppRouter;